import { createAction, props } from "@ngrx/store";
import { ErrorModel } from "@spartacus/core";
import { param } from "../../models/homepage.model";
import { itemState } from "../homepage.state";

export const fetchCategoriesAction = createAction(
    '[Home Page] fetch Categories ',
    props<{ paramsObject: param }>()
);

export const fetchCategoriesActionSuccess = createAction(
    '[Home Page] fetch Categories Success',
    props<{ categories: itemState[] }>()
);

export const fetchCategoriesActionFail = createAction(
    '[Home Page] fetch Categories Fail',
    props<{ payload: ErrorModel }>()
);